import React from 'react'
import Navbar from '../components/Navbar';
import ReviewContent from '../components/ReviewContent';

const TestReviewPage = () => {
  return (
    <div>
      <Navbar/>
      <div className='testReviewContent'>
        <p className='reviewTitle'>Test Review</p>
        <ReviewContent/>
      </div>
    </div>
  )
}

export default TestReviewPage;
